module.exports = __webpack_public_path__ + "img/chat_system.47095196.png";